import { useMutation } from "@apollo/client";

import { SetUserTrustedContactMutation, SetUserTrustedContactMutationVariables } from "@ctypes";
import { SET_USER_TRUSTED_CONTACT, USER } from "@graphql";

export const useSetUserTrustedContact = () => {
  return useMutation<SetUserTrustedContactMutation, SetUserTrustedContactMutationVariables>(
    SET_USER_TRUSTED_CONTACT,
    {
      refetchQueries: [{ query: USER }],
      awaitRefetchQueries: true,
    },
  );
};
